import { EmailSequenceI } from "@/modules/email-templates-sidebar/interfaces";
import { Dispatch, SetStateAction, useState } from "react";

export interface EmailTemplateSequencingI {
  sequenceId?: string;
  setSequenceId: Dispatch<SetStateAction<string | undefined>>;

  emailSequence?: EmailSequenceI;
  setEmailSequence: Dispatch<SetStateAction<EmailSequenceI | undefined>>;
}

/**
 * Hook to manage email sequence
 * expected to be used in the controller component
 * and save state into EmailDraft object in TemplatesContext
 * @returns Interface containing sequence id and email sequence
 */
export const useEmailTemplateSequencing = (
  _sequenceId?: string,
  _emailSequence?: EmailSequenceI
): EmailTemplateSequencingI => {
  const [sequenceId, setSequenceId] = useState<string | undefined>(_sequenceId);
  const [emailSequence, setEmailSequence] = useState<
    EmailSequenceI | undefined
  >(_emailSequence);

  return { sequenceId, setSequenceId, emailSequence, setEmailSequence };
};

export interface EmailTemplateSequencingContextI {
  /**
   * If none is selected, original email is selected
   */
  activeEmailSequenceItemId?: string;
  setActiveEmailSequenceItemId: Dispatch<SetStateAction<string | undefined>>;
}

/**
 * Hook to manage active email sequence item id
 * expected to be used in the context provider
 * @returns Interface containing active email sequence item id
 */
export const useEmailTemplateSequencingContext =
  (): EmailTemplateSequencingContextI => {
    /**
     * If none is selected, original email is selected
     */
    const [activeEmailSequenceItemId, setActiveEmailSequenceItemId] =
      useState<string>();

    return { activeEmailSequenceItemId, setActiveEmailSequenceItemId };
  };
